import "glightbox/dist/css/glightbox.min.css";
import GLightbox from "glightbox";

(function ($) {
    $(function () {
        if (!$(".glightbox").length) {
            return;
        }

        GLightbox({
            selector: ".glightbox",
            touchNavigation: true,
            loop: true,
            autoplayVideos: true,
        });
    });
})(jQuery);
